import { createFileRoute } from '@tanstack/react-router'

import { TermsOfServicePage } from '@/components/infoPages/TermsOfServicePage'

export const Route = createFileRoute('/terms-of-service')({
  component: TermsOfServicePage,
})

